import axios from "axios";
import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";

// import "./AddSessionTextEditor.css";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useRef } from "react";
import { useContext } from "react";
import { serverInfo } from "../../../App";
import { io } from "socket.io-client";
import useFileHandleS3 from "../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../MediaUploadProgressBar";
export default function LiveChatCreate(props) {
  const history = useHistory();

  const socket = useRef();
  /**
   * socket connection
   */
  const { shoketUrl } = useContext(serverInfo);
  useEffect(() => {
    socket.current = io(shoketUrl);
  }, []);
  const [convertedContent, setConvertedContent] = useState(null);
  const [instruction, setInstruction] = useState(null);
  const [imagedata, setImagedata] = useState("");
  const [starList, setStarList] = useState([]);
  const [loading, setLoading] = useState(false);


  // File Handle
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'livechat/images',delKey);



  const [registerInput, setRegister] = useState({
    title: "",
    description: "",
    date: "",
    start_time: "",
    end_time: "",
    max_time: "",
    min_time: "",
    interval: "",
    fee: "",
    star_id: "",
    registration_start_date: "",
    registration_end_date: "",
    error_list: [],
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
    e.persist();
    setRegister({ ...registerInput, [e.target.name]: e.target.value });
  };

  // Fetch Stars Added By Admin
  useEffect(() => {
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });
  }, []);

  const handleChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const registerSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const fData = new FormData();

    fData.append("image", fileKey);
    fData.append("title", registerInput.title);
    fData.append("star_id", registerInput.star_id);
    fData.append("instruction", instruction);
    fData.append("description", convertedContent);
    fData.append("date", registerInput.date);
    fData.append("start_time", registerInput.start_time);
    fData.append("end_time", registerInput.end_time);
    fData.append(
      "registration_start_date",
      registerInput.registration_start_date
    );
    fData.append("registration_end_date", registerInput.registration_end_date);
    fData.append("fee", registerInput.fee);
    fData.append("max_time", registerInput.max_time);
    fData.append("min_time", registerInput.min_time);
    fData.append("interval", registerInput.interval);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/live-chat/add`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar-admin/live-chat/pending");

          socket.current.emit("live_chat_approve", {
            id: res.data.liveChat.id,
          });
        } else {
          setRegister({
            ...registerInput,
            error_list: res.data.validation_errors,
          });
        }
      });
    });
  };

  return (
    <>
      <div className="card card-bg head-line mb-2">
        <div className="text-light d-flex justify-content-center p-2">
          <div className="faTrophy">
            <i className="fa-solid fa-calendar-plus"></i>
          </div>
          <h4 className="mx-3 text-warning p-2">Create Live Session Event</h4>
        </div>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  onSubmit={registerSubmit}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text">Select Stars</label>
                    <div className="col-md-9">
                      <select
                        onChange={handleInput}
                        name="star_id"
                        className="form-control reply-control"
                        value={registerInput.star_id}
                      >
                        <option className="text-black" value="">
                          Choose One
                        </option>
                        {starList.map((user, index) => (
                          <option className="text-black" value={user.id}>
                            {user.first_name} {user.last_name}
                          </option>
                        ))}
                      </select>

                      <span className="text-danger">
                        {registerInput.error_list?.star_id}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">
                      Purpose of live
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control reply-control"
                        placeholder="Input title.."
                        onChange={handleInput}
                        name="title"
                        value={registerInput.title}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.title}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Description</label>
                    <div className="col-md-9">
                      <CKEditor
                        name="description"
                        data={convertedContent}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setConvertedContent(editor.getData());
                        }}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.description}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Instruction</label>
                    <div className="col-md-9">
                      <CKEditor
                        name="instruction"
                        data={instruction}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setInstruction(editor.getData());
                        }}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.instruction}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">Banner</label>
                    <div className="col-sm-5 file-x-i">
                      {fileUrl ? (
                        <img
                          src={fileUrl}
                          alt="..."
                          className="demo-preview-image img-fluid"
                        />
                      ) : (
                        ""
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control reply-control"
                        onChange={(e) => handleChange(e.target.files)}
                        id="image"
                        name="image"
                      />
                     {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      <span className="text-danger">
                        <span className="text-danger">
                          {registerInput.error_list?.image}
                        </span>
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Event Date</label>
                    <div className="col-sm-5">
                      <input
                        type="date"
                        className="form-control reply-control"
                        onChange={handleInput}
                        name="date"
                        value={registerInput.date}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.date}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3 text-warning">
                    <label className="col-sm-3 label-text ">Event Time</label>
                    <div className="col-sm-4">
                      <input
                        type="time"
                        className="form-control reply-control"
                        onChange={handleInput}
                        name="start_time"
                        value={registerInput.start_time}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.start_time}
                      </span>
                    </div>{" "}
                    To
                    <div className="col-sm-4">
                      <input
                        type="time"
                        className="form-control reply-control"
                        onChange={handleInput}
                        name="end_time"
                        value={registerInput.end_time}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.end_time}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3 text-warning">
                    <label className="col-sm-3 label-text ">
                      Registration Start
                    </label>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-control"
                        onChange={handleInput}
                        name="registration_start_date"
                        value={registerInput.registration_start_date}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.registration_start_date}
                      </span>
                    </div>{" "}
                    To
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-control"
                        onChange={handleInput}
                        name="registration_end_date"
                        value={registerInput.registration_end_date}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.registration_end_date}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">
                      Minimum Chatting Time
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        min={0}
                        className="form-control reply-control"
                        placeholder="Enter minimum time"
                        onChange={handleInput}
                        name="min_time"
                        value={registerInput.min_time}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.min_time}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">
                      Maximum Chatting Time
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        min={0}
                        className="form-control reply-control"
                        placeholder="Enter maximum time"
                        onChange={handleInput}
                        name="max_time"
                        value={registerInput.max_time}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.max_time}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">
                      Time Interval
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        min={0}
                        className="form-control reply-control"
                        placeholder="Enter time interval"
                        onChange={handleInput}
                        name="interval"
                        value={registerInput.interval}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.interval}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-3">
                    <label className="col-sm-3 label-text ">
                      Fee Per Minute
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="number"
                        min={0}
                        className="form-control reply-control"
                        placeholder="Enter fee $"
                        onChange={handleInput}
                        name="fee"
                        value={registerInput.fee}
                        step="0.01"
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.fee}
                      </span>
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit">
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
